import { style } from 'typestyle';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { faintBorderColor } from 'src/common-ui/theme';

// TODO cut these styles down and replace where these duplicate other existing styles
// also replace with typestyle instead of mui styles
export const useAgentActionsStyles = makeStyles((theme: Theme) =>
  createStyles({
    countBadge: {
      backgroundColor: '#000',
      color: 'white',
      marginRight: '1rem',
      marginBottom: 'auto',
      marginTop: 'auto',
      borderRadius: '4px',
      '& > span': {
        fontSize: '1.25rem',
        fontWeight: 700,
      },
    },
  })
);

const accordionContainer = style({
  $debugName: 'accordionContainer',
  $nest: {
    '& .s5-MuiAccordion-root': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      boxShadow: 'none',
      borderBottom: '1px solid ' + faintBorderColor,
      $nest: {
        '&:before': {
          display: 'none',
        },
        '.s5-MuiCollapse-wrapper': {
          height: '100%'
        },
        '.s5-MuiCollapse-wrapperInner>div,.s5-MuiAccordionDetails-root': {
          height: '100%'
        }
      },
    },
    '& .s5-MuiAccordionSummary-root': {
      padding: '0.75rem 1rem',
      minHeight: 'unset',
    },
    '& .s5-MuiAccordionSummary-content': {
      margin: '0.75rem 0',
      alignItems: 'center',
    },
    '& .s5-MuiAccordionDetails-root': {
      padding: '0 1rem 1rem 1rem',
      flexDirection: 'column'
    },
    '& .action-avatar': {
      backgroundColor: '#000',
      color: 'white',
      marginRight: '1rem',
      marginBottom: 'auto',
      marginTop: 'auto',
      borderRadius: '4px',
      $nest: {
        '& > span': {
          fontSize: '1rem',
          fontWeight: 700,
        },
      }
    },
  },
});

const groupsAccordionContainer = style({
  height: '100%',

})

const groupTextContainer = style({
  $debugName: 'groupTextContainer',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: '0.25rem',
});

const groupCategory = style({
  $debugName: 'groupCategory',
  fontSize: '0.75rem',
  color: '#999',
  fontWeight: 400,
});

const groupTitle = style({
  $debugName: 'groupTitle',
  fontSize: '1rem',
  color: '#000',
  fontWeight: 700,
});

const actionItem = style({
  $debugName: 'actionItem',
  padding: '0.75rem 1rem',
  width: '100%',
  flexShrink: 1,
  overflowY: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 61 + 24,
  // maxHeight: '800px',
  borderTop: '1px solid ' + faintBorderColor,
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  $nest: {
    '&:first-child': {
      borderTop: 'none',
    },
  },
});

const actionHeader = style({
  $debugName: 'actionHeader',
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  paddingBottom: '0.75rem',
  borderBottom: '1.5px solid #c0c0c0',
  $nest: {
    '&:hover': {
      backgroundColor: '#f4f4f4'
    }
  }
});

const actionIconContainer = style({
  $debugName: 'actionIconContainer',
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  backgroundColor: '#f5f5f5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  $nest: {
    '& > i': {
      fontSize: '1.5rem',
      color: '#333',
    },
  },
});

const actionTextContainer = style({
  $debugName: 'actionTextContainer',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  flex: 1,
});

const actionTitle = style({
  $debugName: 'actionTitle',
  fontWeight: 700,
  fontSize: '1rem',
  color: '#000',
  lineHeight: 1.2,
});

const actionDescription = style({
  $debugName: 'actionDescription',
  color: '#999',
  fontSize: '0.75rem',
  fontWeight: 400,
});

const noResults = style({
  $debugName: 'noResults',
  padding: '2rem',
  textAlign: 'center',
  color: '#999',
});

const stepContainer = style({
  $debugName: 'stepContainer',
  marginTop: '1.5rem',
  marginBottom: '1rem',
});

export default {
  accordionContainer,
  groupTextContainer,
  groupCategory,
  groupTitle,
  actionItem,
  actionHeader,
  actionIconContainer,
  actionTextContainer,
  actionTitle,
  actionDescription,
  noResults,
  stepContainer,
};
